import { CircularProgress, Grid } from "@material-ui/core";
import React from "react";

export const LoadingPage = () => {
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: "80vh" }}
    >
      <CircularProgress
        color={"secondary"}
        style={{ minHeight: "10vh", minWidth: "10vh" }}
      />
    </Grid>
  );
};
